import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';

const Dashboard = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { fetchWithAuth } = useAuth();

  useEffect(() => {
    fetchStats();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchStats = async () => {
    try {
      const response = await fetchWithAuth('/api/stats');
      if (!response.ok) throw new Error('Failed to fetch stats');
      const data = await response.json();
      setStats(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="loading">Loading...</div>;
  if (error) return <div className="error">Error: {error}</div>;

  return (
    <div>
      <h1 style={{ fontSize: '32px', fontWeight: '700', marginBottom: '24px' }}>
        Dashboard
      </h1>

      <div className="grid grid-4">
        <div className="stat-card">
          <div className="stat-value">{stats?.users?.toLocaleString() || 0}</div>
          <div className="stat-label">Total Users</div>
        </div>

        <div className="stat-card">
          <div className="stat-value">{stats?.foods?.toLocaleString() || 0}</div>
          <div className="stat-label">Food Logs</div>
        </div>

        <div className="stat-card">
          <div className="stat-value">{stats?.weights?.toLocaleString() || 0}</div>
          <div className="stat-label">Weight Records</div>
        </div>

        <div className="stat-card">
          <div className="stat-value">{stats?.activities?.toLocaleString() || 0}</div>
          <div className="stat-label">Activities</div>
        </div>
      </div>

      <div className="card" style={{ marginTop: '24px' }}>
        <h2 className="card-title">Welcome to KKAL Admin</h2>
        <p style={{ color: '#666', lineHeight: '1.6' }}>
          This is a minimalistic admin panel for viewing and managing KKAL fitness app data.
          Use the sidebar to navigate between different sections:
        </p>
        <ul style={{ marginTop: '16px', marginLeft: '20px', color: '#666', lineHeight: '1.8' }}>
          <li><strong>Users:</strong> View all registered users</li>
          <li><strong>Fitness Goals:</strong> View user fitness goals and metrics</li>
          <li><strong>Food Logs:</strong> View food entries with nutritional information</li>
          <li><strong>Weights:</strong> Track weight measurements over time</li>
          <li><strong>Activities:</strong> View fitness activities and exercises</li>
          <li><strong>Measurements:</strong> View body measurements</li>
        </ul>
      </div>
    </div>
  );
};

export default Dashboard;


